import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Spinner } from "@/components/ui/Spinner";
import { B2BInvoiceForm } from "../components/B2BInvoiceForm";
import { useB2BInvoicePeriods, useCreateB2BInvoice } from "../hooks/useB2BInvoices";

export default function B2BInvoiceCreatePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const create = useCreateB2BInvoice();
  const { data: periods, isLoading: periodsLoading } = useB2BInvoicePeriods();

  return (
    <div className="max-w-2xl space-y-4">
      <Link to="/b2b-invoices" className="inline-flex items-center text-sm text-slate-600 hover:text-slate-900">
        <ArrowLeft className="mr-1 h-4 w-4" />
        Powrót do listy
      </Link>
      <h1 className="text-2xl font-semibold">Nowa faktura B2B</h1>
      <p className="text-sm text-slate-600">
        Wypełnij dane faktury i załącz plik PDF. Po zapisaniu faktura będzie w
        statusie <strong>Szkic</strong> — możesz ją edytować przed wysłaniem do
        zatwierdzenia.
      </p>

      {/* Periods come from the contract history (months with a B2B day) — wait for
          them so the form's default period is one of them. */}
      {periodsLoading ? (
        <Spinner />
      ) : (
        <B2BInvoiceForm
          initialPeriod={searchParams.get("period") ?? undefined}
          allowedPeriods={periods?.map(
            (p) => `${p.year}-${String(p.month).padStart(2, "0")}`,
          )}
          isSubmitting={create.isPending}
          onSubmit={async (data) => {
            const inv = await create.mutateAsync(data);
            navigate(`/b2b-invoices/${inv.id}`);
          }}
          submitLabel="Zapisz szkic"
        />
      )}
    </div>
  );
}
